/**
 * Variables for use theme wide
 * Defined in page head to be in scope for other scripts
 * abc
 */

if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}

Shopify.theme.options = {
  loadSlider: false
};

Shopify.theme.jsLoadScript = (source, callback) => {
  let script = document.createElement('script');
  const prior = document.getElementsByTagName('script')[0];
  script.async = 1;

  script.onload = script.onreadystatechange = function (_, isAbort) {
    if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
      script.onload = script.onreadystatechange = null;
      script = undefined;
      if (!isAbort) if (callback) callback();
    }
  };

  script.src = source;
  prior.parentNode.insertBefore(script, prior);
};

Shopify.theme.debounce = fn => {
  /**
   * Debounce functions for better performance
   * (c) 2021 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Function} fn The function to debounce
   */
  // Setup a timer
  let timeout; // Return a function to run debounced

  return function () {
    // Setup the arguments
    let context = this;
    let args = arguments; // If there's a timer, cancel it

    if (timeout) {
      window.cancelAnimationFrame(timeout);
    } // Setup the new requestAnimationFrame()


    timeout = window.requestAnimationFrame(function () {
      fn.apply(context, args);
    });
  };
};

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
